import { callFunction } from './functionsClient';
import type { UserProfile, Wallet, Role } from '../types';

export interface MeResponse {
  user: UserProfile;
  role: Role;
  wallet: Wallet;
}

export const authApi = {
  postRegister: () =>
    callFunction<{ user: UserProfile; wallet: Wallet }>('post-register', {
      method: 'POST',
      body: {},
    }),
  me: () => callFunction<MeResponse>('me'),
};
